import { Box, Container } from "@mui/material";
import React, { createContext, useState } from "react";
import { Outlet } from "react-router-dom";
import QMentisBreadCrumb from "../custom-components/QMentisBreadCrumb";

export const MultipleTestCasesContext = createContext(null);
export const TestCasesLoaderContext = createContext(null);

const MultiTestCaseGenerationPage = () => {
  const [multipleUserStories, setMultipleUserStories] = useState([]);
  const [selectedUserStories, setSelectedUserStories] = useState([]);
  const [functionalSpecDocument, setFunctionalSpecDocument] = useState({});
  const [multipleUseCases, setMultipleUseCases] = useState([]);
  const [selectedUseCases, setSelectedUseCases] = useState([]);
  const [testConditions, setTestConditions] = useState({});
  const [testingTechniques, setTestingTechniques] = useState({});
  const [traceabilityMatrix, setTraceabilityMatrix] = useState({});
  const [multiTestCases, setMultiTestCases] = useState([]);
  const [selectedMultipleTestCases, setSelectedMultipleTestCases] = useState([]);
  const [selectedTestingTypes, setSelectedTestingTypes] = useState([]);
  const [testCaseLoaderState, setTestCaseLoaderState] = useState(null);

  const breadCrumbs = [
    {
      title: "Input Story Details",
      status: multipleUserStories.length > 0 ? "Completed" : "In Progress",
    },
    {
      title: "Generate FSD",
      status:
        Object.keys(functionalSpecDocument || {}).length > 0
          ? "Completed"
          : multipleUserStories.length > 0 &&
            testCaseLoaderState === "Functional Specification Document"
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Generate Use Cases",
      status:
        multipleUseCases.length === selectedUserStories.length &&
        multipleUseCases.length > 0
          ? "Completed"
          : selectedUserStories.length > 0 && testCaseLoaderState === "Use Case"
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Generate Test Conditions",
      status:
        testConditions.length > 0
          ? "Completed"
          : multipleUserStories.length > 0 &&
            testCaseLoaderState === "Test Conditions"
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Generate Test Techniques",
      status:
        Object.keys(testingTechniques || {}).length > 0
          ? "Completed"
          : multipleUserStories.length > 0 &&
            testCaseLoaderState === "Test Techniques"
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Select Testing Types",
      status:
      (selectedTestingTypes || []).length > 0
          ? "Completed"
          : multipleUseCases.length > 0 && testCaseLoaderState === "Select Testing Types"
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Test Cases",
      status: (() => {
        if (multipleUserStories.length === 0) {
          return "Not Started";
        }

        // If we have test cases and we're not currently loading, we're completed
        if (multiTestCases.length > 0 && testCaseLoaderState !== "Test Cases") {
          return "Completed";
        }

        // If we're currently generating test cases
        if (testCaseLoaderState === "Test Cases") {
          return "In Progress";
        }

        return "Not Started";
      })(),
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
      }}
    >
      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        <Box
          sx={{
            position: "sticky",
            top: "0",
            width: "100%",
            zIndex: 1000,
            bgcolor: "white",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{ height: "56px" }}
          />
        </Box>

        <Container
          sx={{
            width: "100%",
          }}
        >
          <TestCasesLoaderContext.Provider
            value={{ testCaseLoaderState, setTestCaseLoaderState }}
          >
            <MultipleTestCasesContext.Provider
              value={{
                multipleUserStories,
                setMultipleUserStories,
                selectedUserStories,
                setSelectedUserStories,
                functionalSpecDocument,
                setFunctionalSpecDocument,
                multipleUseCases,
                setMultipleUseCases,
                selectedUseCases,
                setSelectedUseCases,
                testConditions,
                setTestConditions,
                testingTechniques,
                setTestingTechniques,
                traceabilityMatrix,
                setTraceabilityMatrix,
                multiTestCases,
                setMultiTestCases,
                selectedMultipleTestCases,
                setSelectedMultipleTestCases,
                selectedTestingTypes,
                setSelectedTestingTypes,
              }}
            >
              <Outlet />
            </MultipleTestCasesContext.Provider>
          </TestCasesLoaderContext.Provider>
        </Container>
      </Box>
    </Box>
  );
};

export default MultiTestCaseGenerationPage;
